import React from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, Container, Grid, ListItem, ListItemText } from '@mui/material';
import { SimTypography } from 'components/SimTypography';
import { SimButton } from 'components/SimButton';
import { SimSlider } from 'components/SimSlider';

const mock = [
	{
		headerSlide:
			'Diagnostic and Statistical Manual, Fifth Edition (DSM-5) provides standardized criteria to help diagnose Autism.',
		avatar: 'https://www.helpguide.org/wp-content/uploads/boy-playing-with-blocks.jpg',

		subSlideLine1: '',
		subSlideLine2: '',
		subSlideLine3: '',
		subSlideLine4: '',
		subSlideLine5: '',

		headerBodySlide: 'Select examples of diagnostic tools:',

		bodySlideLine1: 'Modified Checklist for Autism in Toddles – Revised (M-CHAT-R),',
		bodySlideLine2: 'Autism Diagnosis Interview – Revised (ADI-R)',
		bodySlideLine3: 'Autism Diagnostic Observation Schedule – Generic (ADOS-G)',
		bodySlideLine4: 'Childhood Autism Rating Scale (CARS)',
		bodySlideLine5: 'Gilliam Autism Rating Scale – 2nd Edition (GARS-2)',

		LinkForBodyLine1: '',
		LinkForBodyLine2: '',
		LinkForBodyLine3: '',
		LinkForBodyLine4: '',
		LinkForBodyLine5: ''
	}
];

const FSSAutismScreeningSummary = () => {
	const theme = useTheme();

	return (
		<Box
			sx={{
				position: 'relative',
				boxShadow: 0,
				paddingBottom: 6,
				backgroundColor: 'none'
			}}>
			<Box height={{ sm: '70vh', lg: '50vh' }}>
				<Box
					display='flex'
					justifyContent='center'
					alignItems='center'
					alignContent='center'
					height={1}
					width={1}>
					<Box
						padding={2}
						width={1}
						sx={{
							bgcolor: 'rgba(0, 0, 0, 0)'
						}}
						display='flex'
						justifyContent='center'
						alignContent={'flex-start'}
						alignItems={'flex-start'}>
						<Container>
							<Box
								display={'flex'}
								flexDirection={'column'}
								justifyItems={'left'}
								alignContent={'flex-start'}>
								<SimTypography
									color={theme.palette.text.primary}
									variant='h4'
									align={'left'}
									paddingcenter='2vw'
									data-aos={'fade-up'}
									gutterBottom
									sx={{
										fontWeight: 700,
										marginTop: theme.spacing(1)
									}}>
									Autism Screening
								</SimTypography>

								<SimTypography
									color={theme.palette.primary.main}
									variant='h6'
									align={'left'}
									data-aos={'fade-up'}>
									Early Detection is{' '}
									<Box component={'span'} color={theme.palette.secondary.main}>
										{' '}
										CRITICAL{' '}
									</Box>
								</SimTypography>

								<Box marginTop={2}>
									<SimTypography color={theme.palette.text.secondary} align={'left'}>
										Autism Spectrum Disorder (ASD) can reliably be diagnosed by 2 years, but the
										average age at diagnosis is five. Two important sources of information in Autism
										screening are –{' '}
										<Box component={'span'} color={theme.palette.primary.main}>
											{' '}
											parent’s descriptions and practitioner’s observation.{' '}
										</Box>
									</SimTypography>
								</Box>

								<Box display='flex' justifyContent={'right'} marginTop={2}>
									<SimButton
										variant='contained'
										size='large'
										href={'/contact'}
										endIcon={
											<Box
												component={'svg'}
												xmlns='http://www.w3.org/2000/svg'
												fill='none'
												viewBox='0 0 24 24'
												stroke='currentColor'
												width={24}
												height={24}>
												<path
													strokeLinecap='round'
													strokeLinejoin='round'
													strokeWidth={2}
													d='M17 8l4 4m0 0l-4 4m4-4H3'
													color={theme.palette.background.default}
												/>
											</Box>
										}>
										Schedule Screen
									</SimButton>
								</Box>
							</Box>
						</Container>
					</Box>
				</Box>
			</Box>

			<Box
				position={'relative'}
				zIndex={2}
				paddingX={2}
				paddingTop={4}
				marginX={{ xs: 'auto', sm: 'auto', md: '0px' }}>
				<Box
					maxWidth={{ xs: '75vw', sm: '85vw', md: '68vw', lg: '68vw' }}
					marginX={'auto'}
					paddingX={'auto'}
					marginY={0}
					paddingY={0}>
					<Box
						marginX={'auto'}
						paddingX={'auto'}
						marginY={0}
						paddingY={0}
						sx={{
							height: { xs: 'auto', md: 1 },
							'& .slick-slide img': {
								objectFit: 'cover'
							},
							'& .slick-list, & .slick-slider, & .slick-track, & .slick-slide > div': {
								height: { xs: 'auto', md: 1 }
							},
							'& .slick-dots': {
								marginTop: { xs: 15, sm: 10, md: 10, lg: 4 },
								top: { xs: '84%', sm: '90%', md: '87%' },
								height: '25px'
							},
							'& .slick-prev': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '0%',
								marginLeft: 0,
								marginRight: '32px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							},
							'& .slick-next': {
								zIndex: 3,
								bottom: 0,
								top: '100%',
								left: '100%',
								marginLeft: '62px',
								right: 0,
								transform: `translate(-100%, calc(-100% - ${theme.spacing(2)}))`,
								marginTop: { xs: '15px', sm: '15px', md: '15px', lg: '15px' },
								width: 62,
								height: '100%',
								'&:before': {
									fontSize: { xs: 26, sm: 26, md: 52, lg: 52 },
									color: alpha(theme.palette.primary.main, 0.5)
								}
							}
						}}>
						<SimSlider
							options={{
								slidesToShow: 1,
								speed: 500,
								autoplay: false
							}}>
							{mock.map((item, i) => (
								<Box key={i}>
									<Card
										sx={{
											display: 'flex',
											flexDirection: {
												xs: 'column',
												md: (i + 1) % 2 === 0 ? 'row' : 'row-reverse'
											},
											boxShadow: 0,
											background: 'transparent'
										}}>
										<CardContent
											sx={{
												display: 'flex',
												alignItems: 'left',
												marginLeft: { sx: 0, md: 2 }
											}}>
											<Box>
												<Box marginTop={0} marginBottom={4}>
													<SimTypography variant={'p'} color={theme.palette.text.secondary}>
														{item.headerSlide}
													</SimTypography>
												</Box>

												<Grid container spacing='2px'>
													<SimTypography variant='h6' color={theme.palette.text.secondary}>
														{item.headerBodySlide === '' ? (
															<Box> </Box>
														) : (
															<Box> {item.headerBodySlide} </Box>
														)}
													</SimTypography>

													{[
														{ line: item.bodySlideLine1, link: item.LinkForBodyLine1 },
														{ line: item.bodySlideLine2, link: item.LinkForBodyLine2 },
														{ line: item.bodySlideLine3, link: item.LinkForBodyLine3 },
														{ line: item.bodySlideLine4, link: item.LinkForBodyLine4 },
														{ line: item.bodySlideLine5, link: item.LinkForBodyLine5 }
													].map((item2, i2) => (
														<Grid item xs={12} key={i2}>
															<Box
																component={ListItem}
																disableGutters
																width={'auto'}
																padding={0}
																margin={0}
																display={'flex'}
																flexDirection={'row'}
																alignItems={'flex-start'}
																justifyItems={'left'}>
																<Box
																	display={'flex'}
																	flexDirection={'row'}
																	color={theme.palette.text.secondary}>
																	<SimTypography variant='h6' paddingX={1}>
																		&#x2022;
																	</SimTypography>
																	<ListItemText primary={item2.line} />
																</Box>
															</Box>
														</Grid>
													))}
												</Grid>
											</Box>
										</CardContent>
									</Card>
								</Box>
							))}
						</SimSlider>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

export { FSSAutismScreeningSummary };
